import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(['xl']),
  className: PropTypes.string,
};

const Content = ({ children, size, className }) => {
  const classes = classNames({
    'signup-layout-content': true,
    [`signup-layout-content-${size}`]: !!size,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

Content.propTypes = propTypes;

export default Content;
